module.exports = __webpack_public_path__ + "plat/static/img/approval.92807fd9.svg";